import { createGlobalState } from 'react-hooks-global-state';
import Cyano from '../utils/DApp/Cyano';
import Onto from '../utils/DApp/Onto';
import { WalletVcItem } from '../utils/vc/types';

type State = {
  ontId: string;
  dApp: Cyano | Onto | null; // todo remove class
  addressList: WalletVcItem[];
  scoreLoading: boolean;
  score: string;
}

const globalState = createGlobalState<State>({
  ontId: '',
  dApp: null,
  addressList: [],
  scoreLoading: false,
  score: '',
});

// eslint-disable-next-line
export const useGlobalState = globalState.useGlobalState;
